import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";

export const FloatingContact = () => {
    const [show, setShow] = useState(false);
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            const y = window.scrollY;
            setShow(y > 700);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (hidden) return null;

    return (
        <div
            data-testid="floating-contact"
            className={`fixed bottom-6 right-6 z-40 transition-all duration-500 ${
                show
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-6 pointer-events-none"
            }`}
        >
            <div className="relative group">
                <button
                    data-testid="floating-contact-close"
                    onClick={(e) => {
                        e.stopPropagation();
                        setHidden(true);
                    }}
                    aria-label="Dismiss"
                    className="absolute -top-2 -left-2 h-6 w-6 grid place-items-center bg-white border border-slate-300 text-slate-500 hover:text-[#0A1428] rounded-full opacity-0 group-hover:opacity-100 transition-opacity z-10"
                >
                    <X size={12} strokeWidth={2} />
                </button>
                <Link
                    to="/contact"
                    data-testid="floating-contact-cta"
                    className="btn-primary inline-flex items-center gap-3 px-5 py-3.5 text-sm font-bold tracking-wide uppercase rounded-sm shadow-[0_18px_40px_-12px_rgba(240,73,62,0.55)]"
                >
                    <span className="relative inline-flex h-2 w-2">
                        <span className="absolute inline-flex h-full w-full rounded-full bg-white/70 pulse-ring" />
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-white" />
                    </span>
                    <MessageCircle size={16} strokeWidth={2} />
                    <span className="hidden sm:inline">Contact us</span>
                </Link>
            </div>
        </div>
    );
};
